import { getStoredUtm } from './signupUtm.js';

const formStartedEmails = new Set();
let lastFormStartedTraits = {};

function canUseCustomerIo() {
  return typeof window !== 'undefined' && window._cio;
}

function withUtm(traits = {}) {
  return { ...getStoredUtm(), ...traits };
}

export function isIdentifiableCustomerIoEmail(email) {
  if (!email || typeof email !== 'string') {
    return false;
  }
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function identifyCustomerIo(email, traits = {}) {
  if (!canUseCustomerIo() || !email) {
    return;
  }

  window._cio.identify({ id: email, email, ...withUtm(traits) });
}

export function trackCustomerIoEvent(eventName, data = {}, email = null) {
  if (!canUseCustomerIo()) {
    return;
  }

  if (email) {
    identifyCustomerIo(email, data);
  }

  window._cio.track(eventName, withUtm(data));
}

/** Pre-identify on client success; server fires signed_up after welcome email. */
export function identifyCustomerIoSignupProspect(email, traits = {}) {
  identifyCustomerIo(email, traits);
}

/**
 * Customer.io drops anonymous events. Only fire form_started after we have an
 * email so Journeys/Slack (User Signup Failed) can enroll the person.
 */
export function trackCustomerIoFormStarted(traits = {}, email = null) {
  if (!isIdentifiableCustomerIoEmail(email)) {
    return;
  }

  const id = String(email).trim().toLowerCase();
  if (formStartedEmails.has(id)) {
    return;
  }
  formStartedEmails.add(id);
  lastFormStartedTraits = { ...traits };
  trackCustomerIoEvent('form_started', traits, email);
}

export function trackCustomerIoFormSubmitted(traits = {}, email = null) {
  trackCustomerIoEvent('form_submitted', traits, email);
}

/** Client-only failure signal; success is server welcome_email_sent + signed_up. */
export function trackCustomerIoSignupFailed(traits = {}, email = null) {
  trackCustomerIoEvent(
    'signup_failed',
    { ...lastFormStartedTraits, ...traits },
    email
  );
}

export function trackCustomerIoAccountRecovery(action, traits = {}, email = null) {
  trackCustomerIoEvent('account_recovery', { action, ...traits }, email);
}

export function trackCustomerIoPage(path) {
  if (!canUseCustomerIo()) {
    return;
  }

  window._cio.page(path, withUtm());
}
